import { Injectable } from '@angular/core';
import { environment } from '@env';

export interface FirebaseConfig {
  firebase: {
    apiKey: string;
    authDomain: string;
    databaseURL: string;
    projectId: string;
    storageBucket: string;
    messagingSenderId: string;
  };
}

const domain = window.location.hostname;

@Injectable({
  providedIn: 'root'
})
export class FirebaseConfigService {
  constructor() {}
  fireConfig(): FirebaseConfig {
    const firebaseConfig: FirebaseConfig = environment[environment.alias[domain]].firebase;
    if (firebaseConfig) {
      return firebaseConfig;
    } else {
      // Devuelvo la primera config
      for (const key in environment) {
        if (environment.hasOwnProperty(key)) {
          if (environment[key].hasOwnProperty('firebase')) {
            return environment[key]['firebase'];
          }
        }
      }
    }
  }
}
